/* RapideSIM product buybox — picker, segmented filter, sticky mobile bar. Deferred, no deps. */
(function () {
  var buybox = document.getElementById('rs-buybox');
  if (!buybox) return;

  var swatches = Array.prototype.slice.call(buybox.querySelectorAll('.variant-swatch'));
  var qtyInput = document.getElementById('quantity-input');
  var totalEl = document.getElementById('total-price');
  var regularEl = document.getElementById('regular-price');
  var buyBtn = document.getElementById('buy-now');
  var stickyBar = document.getElementById('rs-sticky');
  var stickyPlan = document.getElementById('rs-sticky-plan');
  var stickyPrice = document.getElementById('rs-sticky-price');
  var MONEY_FORMAT = buybox.getAttribute('data-money-format') || '${{amount}}';

  var selectedId = null, cents = 0, compareCents = 0;

  function fmt(c) {
    var a = (c / 100).toFixed(2);
    return MONEY_FORMAT
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(c / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, a);
  }

  function updateTotal() {
    var q = parseInt(qtyInput.value, 10) || 1;
    totalEl.textContent = fmt(cents * q);
    regularEl.textContent = compareCents > cents ? fmt(compareCents * q) : '';
    if (stickyPrice) stickyPrice.textContent = fmt(cents * q);
  }

  function select(sw) {
    swatches.forEach(function (s) { s.classList.remove('is-selected'); });
    sw.classList.add('is-selected');
    selectedId = sw.getAttribute('data-variant-id');
    cents = parseInt(sw.getAttribute('data-cents'), 10) || 0;
    compareCents = parseInt(sw.getAttribute('data-compare-cents'), 10) || 0;
    if (stickyPlan) stickyPlan.textContent = sw.getAttribute('data-label') || '';
    updateTotal();
  }

  swatches.forEach(function (sw) {
    sw.addEventListener('click', function () { select(sw); });
    sw.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(sw); }
    });
  });

  document.getElementById('qty-plus').addEventListener('click', function () {
    qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; updateTotal();
  });
  document.getElementById('qty-minus').addEventListener('click', function () {
    var q = parseInt(qtyInput.value, 10) || 1;
    if (q > 1) { qtyInput.value = q - 1; updateTotal(); }
  });
  qtyInput.addEventListener('input', updateTotal);

  function addAndCheckout(variantId, qty) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (e) { console.error('cart/add failed', e); });
  }
  function buy() { addAndCheckout(selectedId, parseInt(qtyInput.value, 10) || 1); }
  buyBtn.addEventListener('click', buy);
  var stickyBuy = document.getElementById('rs-sticky-buy');
  if (stickyBuy) stickyBuy.addEventListener('click', buy);

  /* Price-table ADD buttons (second purchase path, ETravelSim pattern) */
  document.querySelectorAll('.rs-row-add').forEach(function (btn) {
    btn.addEventListener('click', function () {
      addAndCheckout(btn.getAttribute('data-variant-id'), 1);
    });
  });

  /* Install guide: iOS / Android switch */
  var osBtns = document.querySelectorAll('.rs-os-btn');
  osBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      osBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var os = btn.getAttribute('data-os');
      document.querySelectorAll('.rs-os-panel').forEach(function (p) {
        p.hidden = p.getAttribute('data-os') !== os;
      });
      document.querySelectorAll('.rs-install-more').forEach(function (p) {
        p.hidden = p.getAttribute('data-os-link') !== os;
      });
    });
  });

  /* Sticky mobile bar: show while the main buy button is above the viewport.
     Passive scroll listener (rAF-throttled) — IntersectionObserver is unreliable
     in some embedded webviews. */
  if (stickyBar) {
    /* re-parent to <body>: ancestor transforms (Dawn scroll animations) would
       otherwise turn position:fixed into position:absolute-like behavior */
    document.body.appendChild(stickyBar);
    var ticking = false;
    var checkSticky = function () {
      ticking = false;
      var on = buyBtn.getBoundingClientRect().bottom < 0;
      stickyBar.classList.toggle('is-visible', on);
      /* remonte le lanceur de chat (Richpanel) pour qu'il ne masque pas le bouton d'achat */
      document.documentElement.classList.toggle('rs-bottombar-on', on);
      if (on) { document.documentElement.style.setProperty('--rs-bottombar-h', (stickyBar.offsetHeight + 6) + 'px'); }
    };
    var onScroll = function () {
      if (!ticking) { ticking = true; setTimeout(checkSticky, 100); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    checkSticky();
  }

  if (swatches.length) select(swatches[0]);
})();
